export const WHATSAPP_NUMBER = "5582999763522";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Olá!%20Quero%20saber%20mais%20sobre%20os%20serviços%20do%20Negócio%20Conectado.`;
export const whatsappUrl = (msg: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
